import { Locale } from 'modules/i18n';

export default {
  [Locale.en]: {
    title: 'Edit Task',
    submit: 'Edit',
    paused: 'Paused',
    active: 'Active',
    details: 'Details',
    taskName: 'Task name',
    execute: 'Execute',
    when: 'When',
    payWith: 'Pay with',
    startDate: 'Start Date: <b>{value}</b>',
    costPerAction: 'Cost per action: <b>{value}</b>',
    monthlyCost: 'Monthly cost: <b>{value}</b>',
    totalSpent: 'Total Spent',
  },
};
